/**
 * Responsive `sizes` expressions for Next.js `<Image>` components.
 *
 * Each export matches a specific layout context. Values are based on:
 * - Container max-width: 1704px (`.container`), with ~3rem padding = ~1656px usable
 * - Breakpoints: mobile < 769px, tablet ≥ 769px, tablet-landscape ≥ 993px,
 *   laptop ≥ 1201px, desktop ≥ 1441px
 * - vw approximations are intentionally conservative (slightly smaller than actual
 *   CSS width) — the browser's `srcset` `w`-descriptor selection handles Retina
 *   and density automatically, so under-sizing `sizes` saves bandwidth without
 *   sacrificing sharpness.
 */

/** Card in a 4-column grid: 1 col mobile → 2 → 3 → 4 */
export const CARD_GRID_4 = "(max-width: 769px) 100vw, (max-width: 993px) 50vw, (max-width: 1201px) 33vw, 25vw";

/** Card in a 3-column grid: 1 col mobile → 2 → 3 */
export const CARD_GRID_3 = "(max-width: 769px) 100vw, (max-width: 993px) 50vw, 33vw";

/** Card in a 2-column grid: 1 col mobile → 2 */
export const CARD_GRID_2 = "(max-width: 769px) 100vw, 50vw";

/** TwoColsCardSection card: full-width mobile, ~35% of viewport on desktop (70% of 50% column) */
export const TWO_COLS_CARD = "(max-width: 769px) 100vw, 35vw";

/** Full-width image (hero, carousel, section backgrounds, modals, etc.) */
export const FULL_WIDTH = "100vw";

/** HorizontalSlidingCardsSection slide: 1.5 slides mobile → 2.5 tablet → 3.5 desktop */
export const HORIZONTAL_SLIDE = "(max-width: 769px) 100vw, (max-width: 993px) 50vw, (max-width: 1441px) 33vw, 25vw";